import { useTranslation, Trans } from 'react-i18next';

const AboutUsPage = () => {
	const { t } = useTranslation();

	return (
		<div className="about-us">
			<img className="world-icon" src={t('WorldIconUrl')} alt="World Icon" />
			<h1 className="title">{t('AboutUsLabel')}</h1>
			<div className="text">
				<Trans i18nKey="AboutUsText"/>
			</div>
		</div>
	);
};

export default AboutUsPage;
